import { useEffect, useRef } from 'react';

export const useTimeout = (callback, delay) => {
	const savedCallback = useRef();
	
	// Remember the latest callback.
	useEffect(() => {
		savedCallback.current = callback;
	}, [callback]);
	
	// Set up the interval.
	useEffect(() => {
		function tick() {
			savedCallback.current();
		}
		if (delay !== null) {
			let id = setTimeout(tick, delay);
			return () => {
				return clearTimeout(id);
			};
		}
	}, [delay]);
}
